// test-pdf.component.ts
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Pdf, PdfTemplate } from '../utility/pdf/Pdf';

@Component({
  selector: 'app-test-pdf',
  imports: [CommonModule],
  template: `
    <div
      style="padding:2rem; font-family:'Georgia', serif; background:#faf4f0; min-height:100vh;"
    >
      <h2
        style="font-size:1.6rem; font-weight:400; color:var(--text-dark); margin-bottom:0.4rem;"
      >
        Test PDF Templates
      </h2>
      <p
        style="font-size:0.85rem; color:var(--text-light); margin-bottom:2rem;"
      >
        Clicca un template per aprire il PDF in anteprima
      </p>

      <div style="display:flex; gap:1rem; flex-wrap:wrap;">
        <button
          *ngFor="let t of templates"
          (click)="test(t.key)"
          [style.background]="t.bg"
          [style.color]="t.color"
          [style.border]="'1px solid ' + t.border"
          style="padding:1rem 1.75rem; border-radius:10px; cursor:pointer; font-size:0.85rem; font-family:Georgia,serif; letter-spacing:0.04em; transition:opacity 0.2s;"
          onmouseover="this.style.opacity='0.8'"
          onmouseout="this.style.opacity='1'"
        >
          {{ t.label }}
        </button>
      </div>
    </div>
  `,
})
export class TestPdfComponent {
  templates: {
    key: PdfTemplate;
    label: string;
    bg: string;
    color: string;
    border: string;
  }[] = [
    {
      key: 'ivory',
      label: 'Ivory Classic',
      bg: '#faf4f0',
      color: '#35261a',
      border: '#d4b896',
    },
    {
      key: 'blanc',
      label: 'Blanc Minimal',
      bg: '#ffffff',
      color: '#0f0f0f',
      border: '#c8c8c8',
    },
    {
      key: 'blush',
      label: 'Blush Romance',
      bg: '#fff5f4',
      color: '#6b2e28',
      border: '#e0b8b3',
    },
    {
      key: 'noir',
      label: '✦  Noir Luxury',
      bg: '#12100c',
      color: '#d4aa5f',
      border: '#41370a',
    },
  ];

  private mockData = {
    customer_data: {
      bride: {
        name: 'Sofia',
        lastname: 'Rossi',
        address: 'Via Roma 12, Milano',
        dateOfBirth: '1995-06-15',
        placeOfBirth: 'Milano',
      },
      wedding: {
        date: '2026-09-20',
        location: 'Villa Borghese, Roma',
        time: '16:00',
        contract: {
          dateOfContract: '2026-03-09',
        },
        service: [
          { service: 'Bridal Makeup', checked: true },
          { service: 'Bridal Hair', checked: true },
          { service: 'Trial Makeup', checked: true },
          { service: 'Bridesmaid Makeup', checked: false },
        ],
      },
    },

    contract_info: {
      business_name: 'Luna Beauty Studio',
      full_name: 'Alexandra Ghervasuc',
      address: 'Viale Roma 36, Foligno, 06034',
      telephone: '+39 324 794 2247',
      email: 'info@lunabeautystudio.com',
      piva: '15065881003',
      signature: null,
      payment: {
        deposit_amount: 100,
        deposit_method: 'cash' as const,
        final_payment_method: 'cash' as const,
        final_payment_when: 'wedding_day' as const,
        final_payment_days: undefined,
      },
      location: {
        needs_table: true,
        needs_natural_light: true,
        needs_power_outlet: true,
        extra_notes: '',
      },
      cancellation: {
        deposit_refundable: false,
        postponement_policy: 'transfer_date' as const,
        extra_notes: '',
      },
    },
  };

  test(template: PdfTemplate) {
    const pdf = new Pdf();
    pdf.print(
      this.mockData.customer_data,
      { ...this.mockData.contract_info, template },
      false,
      true,
    );
  }
}
